import { render } from "./CustomBarChart.vue?vue&type=template&id=455b5b59&scoped=true"
import script from "./CustomBarChart.vue?vue&type=script&lang=js"
export * from "./CustomBarChart.vue?vue&type=script&lang=js"

import "./CustomBarChart.vue?vue&type=style&index=0&id=455b5b59&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455b5b59"]])

export default __exports__